export default __webpack_public_path__ + "static/media/sharing.a0d9bcdc.png";